
import React, { memo } from 'react';
import { View, Text, StyleSheet } from 'react-native';

interface MessageDateBadgeProps {
  text: string;
  style?: any;
}

const MessageDateBadge = memo(function MessageDateBadge({ text, style }: MessageDateBadgeProps) {
  return (
    <View style={[styles.badge, style]}>
      <Text style={styles.badgeText}>{text}</Text>
    </View>
  );
});

export default MessageDateBadge;

const styles = StyleSheet.create({
  badge: {
    paddingVertical: 4,
    paddingHorizontal: 8,
    alignItems: 'center',
    borderWidth: 0.631,
    borderColor: '#C4C2BA', // --Colors-Bege-Cotton-Seed
    backgroundColor: '#DAD8CF', // --Colors-Bege-Westar
    borderRadius: 52,
    flexDirection: 'row',
    gap: 8,
  },
  badgeText: {
    color: '#56554D', // --Colors-Bege-Chicago
    fontFamily: 'Inter_500Medium',
    fontSize: 10,
    lineHeight: 14, // 140% of 10px
  },
});
